import { BookingStateEnum } from '@xeetr/types/enums'
import { FoodBookingModel, ViewTable } from '@xeetr/types/models'
import { DATE_FORMAT_SHORTYEAR } from '@xeetr/types/utils'
import { format, parseISO } from 'date-fns'
import { de } from 'date-fns/locale'
import { Copy } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { useBookings } from '@/hooks/useBookings'
import { useTenant } from '@/hooks/useTenant'

export const TableColumn = (booking: FoodBookingModel) => {
  const { bookings } = useBookings()
  const { tenant } = useTenant()

  if (!booking.tables || booking.tables.length === 0 || !tenant) {
    return <></>
  }

  const isDoubleBooked = (tableBooking: FoodBookingModel, table: ViewTable) => {
    if (!tableBooking.tables || !Array.isArray(tableBooking.tables)) {
      return false
    }

    const tableBookingTime = format(
      parseISO(tableBooking.from.toISOString()),
      DATE_FORMAT_SHORTYEAR,
      {
        locale: de,
      }
    )
    const bookingTime = format(parseISO(booking.from.toISOString()), DATE_FORMAT_SHORTYEAR, {
      locale: de,
    })
    return (
      tableBooking.tables.find((t) => t.id === table.id) &&
      tableBookingTime === bookingTime &&
      tableBooking.id !== booking.id &&
      tableBooking.state?.status !== BookingStateEnum.OPEN &&
      booking.state?.status !== BookingStateEnum.OPEN &&
      tenant?.markMultipleUsedTables
    )
  }

  // build array of table nodes with commas only between items
  const tableNodes = booking.tables.map((table, index) => {
    const isDouble = bookings?.find((tb) => isDoubleBooked(tb as FoodBookingModel, table))

    const label = (
      <>
        {table.name} {table.size !== null && table.size > 0 ? `(${table.size})` : ''}
      </>
    )

    const comma = index < booking.tables.length - 1 ? ', ' : ''

    if (isDouble) {
      return (
        <span key={`${table.id}-${booking.id}`}>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-flex items-center gap-1">
                {label} <Copy className="h-3 w-3" />
                {comma}
              </span>
            </TooltipTrigger>
            <TooltipContent color="secondary">
              <p>Doppelte Belegung</p>
            </TooltipContent>
          </Tooltip>
        </span>
      )
    }

    return (
      <span key={`${table.id}-${booking.id}`}>
        {label}
        {comma}
      </span>
    )
  })

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          {tableNodes.slice(0, 5)}
          {booking.tables.length > 5 && <span key={`more-tables-${booking.id}`}>...</span>}
        </div>
      </TooltipTrigger>
      <TooltipContent color="secondary">
        <div>{tableNodes}</div>
      </TooltipContent>
    </Tooltip>
  )
}
